// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-list {
  width: var(--server-list-width);
  background-color: var(--bg-tertiary);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  border-right: 1px solid var(--glass-border);
  z-index: 50;
  overflow: hidden;
}

.server-list-scroll {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  overflow-y: auto;
  overflow-x: hidden !important;
  width: 100%;
  padding: 0 12px;
  scrollbar-width: none;
}

.server-list-scroll::-webkit-scrollbar {
  display: none;
}

.server-icon {
  position: relative;
  width: 52px;
  height: 52px;
  border-radius: 50% !important;
  background-color: var(--bg-secondary);
  cursor: pointer;
  transition: all var(--transition-normal);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-sm);
  border: 1px solid transparent;
  overflow: hidden !important;
  flex-shrink: 0;
  isolation: isolate;
}

.server-icon:hover {
  background-color: var(--bg-modifier-hover);
  border-color: var(--glass-border);
  box-shadow: var(--shadow-md);
  border-radius: 50% !important;
}

.server-icon.active {
  background-color: var(--brand-primary);
  color: white;
  border-radius: 50% !important;
  box-shadow: 0 8px 20px rgba(153, 27, 27, 0.4);
}

.active-indicator {
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 24px;
  background-color: var(--brand-primary);
  border-radius: 0 4px 4px 0;
  box-shadow: 2px 0 10px var(--brand-primary);
}

.server-icon-inner {
  width: 100%;
  height: 100%;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--bg-secondary);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden !important;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  mask-image: radial-gradient(white, black);
  color: var(--text-secondary);
}

.server-icon-img {
  width: 100%;
  height: 100%;
  border-radius: 50% !important;
  object-fit: cover;
  display: block;
}

.server-icon:hover .server-icon-inner {
  color: var(--text-primary);
}

.server-icon.active .server-icon-inner {
  background: var(--brand-primary);
  border-radius: 50% !important;
  color: white;
}

.server-icon.home,
.server-icon.action-btn {
  border-radius: 50% !important;
}

.server-icon.home .server-icon-inner,
.server-icon.action-btn .server-icon-inner {
  border-radius: 50% !important;
}

.server-icon.home {
  background-color: var(--bg-primary);
  border: 1px solid var(--glass-border);
}

.server-icon.home.active {
  background-color: var(--brand-primary);
  border-color: transparent;
}

.server-emoji {
  font-size: 24px;
}

.server-letter {
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
}

.server-separator {
  width: 32px;
  height: 2px;
  background: linear-gradient(to right, transparent, var(--glass-border), transparent);
  margin: 4px 0;
  opacity: 0.5;
}

.action-btn {
  background-color: rgba(255, 255, 255, 0.02);
  border: 1.5px dashed var(--text-muted);
  color: var(--text-muted);
}

.action-btn:hover {
  border-style: solid;
  border-color: var(--brand-primary);
  color: var(--brand-primary);
  background-color: rgba(153, 27, 27, 0.08);
}

.server-tooltip {
  position: absolute;
  left: 70px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 9999;
  background-color: var(--bg-floating);
  backdrop-filter: blur(12px);
  color: var(--text-primary);
  padding: 10px 16px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all var(--transition-normal);
  z-index: 10000;
  box-shadow: var(--shadow-xl);
  border: 1px solid var(--glass-border);
}

.server-icon:hover .server-tooltip {
  opacity: 1;
  left: 78px;
}

/* Server Context Menu */
.server-context-menu {
  position: fixed;
  z-index: 10000;
  width: 220px;
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 6px;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.65);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.context-menu-header {
  padding: 8px 10px 6px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 4px;
}

.context-server-name {
  font-size: 13px;
  font-weight: 800;
  color: #f8fafc;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.context-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 8px;
  background: transparent;
  border: none;
  color: #cbd5e1;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  width: 100%;
  text-align: left;
}

.context-menu-item:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
}

.context-menu-item.primary {
  color: #38bdf8;
}

.context-menu-item.primary:hover {
  background: rgba(56, 189, 248, 0.15);
  color: #7dd3fc;
}

.context-menu-item.danger {
  color: #f87171;
}

.context-menu-item.danger:hover {
  background: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
}

.context-menu-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 4px 0;
}

`, "",{"version":3,"sources":["webpack://./src/components/ServerList/ServerList.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,iDAAiD;EACjD,2BAA2B;EAC3B,yDAAyD;EACzD,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oFAAoF;EACpF,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,oCAAoC;EACpC,2BAA2B;EAC3B,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,wCAAwC;EACxC,cAAc;EACd,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,aAAa;AACf","sourcesContent":[".server-list {\n  width: var(--server-list-width);\n  background-color: var(--bg-tertiary);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0;\n  border-right: 1px solid var(--glass-border);\n  z-index: 50;\n  overflow: hidden;\n}\n\n.server-list-scroll {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  overflow-y: auto;\n  overflow-x: hidden !important;\n  width: 100%;\n  padding: 0 12px;\n  scrollbar-width: none;\n}\n\n.server-list-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.server-icon {\n  position: relative;\n  width: 52px;\n  height: 52px;\n  border-radius: 50% !important;\n  background-color: var(--bg-secondary);\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-sm);\n  border: 1px solid transparent;\n  overflow: hidden !important;\n  flex-shrink: 0;\n  isolation: isolate;\n}\n\n.server-icon:hover {\n  background-color: var(--bg-modifier-hover);\n  border-color: var(--glass-border);\n  box-shadow: var(--shadow-md);\n  border-radius: 50% !important;\n}\n\n.server-icon.active {\n  background-color: var(--brand-primary);\n  color: white;\n  border-radius: 50% !important;\n  box-shadow: 0 8px 20px rgba(153, 27, 27, 0.4);\n}\n\n.active-indicator {\n  position: absolute;\n  left: -20px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 24px;\n  background-color: var(--brand-primary);\n  border-radius: 0 4px 4px 0;\n  box-shadow: 2px 0 10px var(--brand-primary);\n}\n\n.server-icon-inner {\n  width: 100%;\n  height: 100%;\n  border-radius: 50% !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--bg-secondary);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden !important;\n  -webkit-mask-image: -webkit-radial-gradient(white, black);\n  mask-image: radial-gradient(white, black);\n  color: var(--text-secondary);\n}\n\n.server-icon-img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50% !important;\n  object-fit: cover;\n  display: block;\n}\n\n.server-icon:hover .server-icon-inner {\n  color: var(--text-primary);\n}\n\n.server-icon.active .server-icon-inner {\n  background: var(--brand-primary);\n  border-radius: 50% !important;\n  color: white;\n}\n\n.server-icon.home,\n.server-icon.action-btn {\n  border-radius: 50% !important;\n}\n\n.server-icon.home .server-icon-inner,\n.server-icon.action-btn .server-icon-inner {\n  border-radius: 50% !important;\n}\n\n.server-icon.home {\n  background-color: var(--bg-primary);\n  border: 1px solid var(--glass-border);\n}\n\n.server-icon.home.active {\n  background-color: var(--brand-primary);\n  border-color: transparent;\n}\n\n.server-emoji {\n  font-size: 24px;\n}\n\n.server-letter {\n  font-size: 18px;\n  font-weight: 900;\n  text-transform: uppercase;\n}\n\n.server-separator {\n  width: 32px;\n  height: 2px;\n  background: linear-gradient(to right, transparent, var(--glass-border), transparent);\n  margin: 4px 0;\n  opacity: 0.5;\n}\n\n.action-btn {\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1.5px dashed var(--text-muted);\n  color: var(--text-muted);\n}\n\n.action-btn:hover {\n  border-style: solid;\n  border-color: var(--brand-primary);\n  color: var(--brand-primary);\n  background-color: rgba(153, 27, 27, 0.08);\n}\n\n.server-tooltip {\n  position: absolute;\n  left: 70px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 9999;\n  background-color: var(--bg-floating);\n  backdrop-filter: blur(12px);\n  color: var(--text-primary);\n  padding: 10px 16px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 800;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all var(--transition-normal);\n  z-index: 10000;\n  box-shadow: var(--shadow-xl);\n  border: 1px solid var(--glass-border);\n}\n\n.server-icon:hover .server-tooltip {\n  opacity: 1;\n  left: 78px;\n}\n\n/* Server Context Menu */\n.server-context-menu {\n  position: fixed;\n  z-index: 10000;\n  width: 220px;\n  background: rgba(15, 23, 42, 0.95);\n  backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 6px;\n  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.65);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.context-menu-header {\n  padding: 8px 10px 6px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  margin-bottom: 4px;\n}\n\n.context-server-name {\n  font-size: 13px;\n  font-weight: 800;\n  color: #f8fafc;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.context-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: transparent;\n  border: none;\n  color: #cbd5e1;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n  width: 100%;\n  text-align: left;\n}\n\n.context-menu-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #f8fafc;\n}\n\n.context-menu-item.primary {\n  color: #38bdf8;\n}\n\n.context-menu-item.primary:hover {\n  background: rgba(56, 189, 248, 0.15);\n  color: #7dd3fc;\n}\n\n.context-menu-item.danger {\n  color: #f87171;\n}\n\n.context-menu-item.danger:hover {\n  background: rgba(239, 68, 68, 0.18);\n  color: #fca5a5;\n}\n\n.context-menu-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.06);\n  margin: 4px 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
